import styled from "styled-components";
import {HomepageHeaderArenaSkeletonDefaultBox} from "./home-page-header-arena-skeleton.default.box";

export const HomepageHeaderArenaSkeletonSIBox = styled(HomepageHeaderArenaSkeletonDefaultBox)`
    &::before {
        top: 0;
        left: 0;
        right: 0; 
        bottom: 0;
        border-radius: 0;
    }
`;